/** @module csi/table/QueryViewAllController */
define([
	"dojo/_base/declare",
	"csi/sessionConstants",
	"csi/table/QueryMoreController"
], function(declare,sessionConstants,QueryMoreController) {

	return declare(QueryMoreController, {
		
		/**
		 * @override
		 * "View All" action, query for "All" either incrementally or at once
		 */
		_widgetQueryMore: function(domNode){
			var view = this.widget;
			if (view.incrementalQuerySize){
				// Incremental load allowed, perform view all with incremental load
				view.queryDisplayCountTarget = view.queryTotalCount;
				return view.queryMore(domNode);
			} else {
				// Incremental load not allowed, load all at once
				return view.queryMore(domNode, sessionConstants.maxResultSize);
			}
		}
	});
});